import axios from 'axios';
import qs from 'qs';
const REQUEST_KEY = 'JFISABNKMSNDUGAKDKNSIU12JNF';
var REQUEST_URL = '/api/web';
import conf from '../../static/conf.js';
if(conf.request_url){
   REQUEST_URL = conf.request_url;
}
var http = axios.create({
  baseURL: REQUEST_URL,
  headers: {
    'Content-Type': 'multipart/form-data'
   }
});
http.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
	var access_token = localStorage.getItem('access_token');
	if (access_token) {
		config.headers['X-Api-Key'] = access_token;
	}
    return config;
  }, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  });
http.interceptors.response.use(function (response) {
    // 对响应数据做点什么
	if (response.data.code != 200) {
		throw response.data.message;
	}
    return response.data.data;
  }, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  });
export default {
  request_url:REQUEST_URL,
  http:http,
  get (url,data,config,success,error) {
    var params = this.arrToParams(data);
    axios.get(REQUEST_URL + url,{params,...config}).then(success).catch(error);//params:{},header:{},xx:{},xx:{}
  },
  post (url,data,config,success,error) {
    var params = this.arrToParams(data);
    axios.post(REQUEST_URL + url,qs.stringify(params),config).then(success).catch(error);
  },
  postFile (url,data,config,success,error) {
    axios.post(REQUEST_URL + url,data,config).then(success).catch(error);
  },
  arrToParams (arr) {
    var params = {};
    if(arr != {}){
      for(let item_ in arr){
        params[item_] = arr[item_];
      }
    }
    return params;
  },
  getBirth:function(idCard){
    var birthday = "";
    if(idCard != null && idCard != ""){
      if(idCard.length == 15){
        birthday = "19"+idCard.slice(6,12);
      } else if(idCard.length == 18){
        birthday = idCard.slice(6,14);
      }
      birthday = birthday.replace(/(.{4})(.{2})/,"$1-$2-");
      //通过正则表达式来指定输出格式为:1990-01-01
    }
    return birthday;
  },
  getSex:function(idCard){
    var sexStr = '';
    if (parseInt(idCard.slice(-2, -1)) % 2 == 1) {
      sexStr = 1;
    }
    else {
      sexStr = 2;
    }
    return sexStr;
  },
  isCard (num) {
    num = num.toUpperCase();
    //身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X。
    if (!(/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(num))) {
      return false;
    }
    //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
    //下面分别分析出生日期和校验位
    var len, re;
    len = num.length;
    if (len == 15) {
      re = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
      var arrSplit = num.match(re);



      //检查生日日期是否正确
      var dtmBirth = new Date('19' + arrSplit[2] + '/' + arrSplit[3] + '/' + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        return false;
      }
      else {
        //将15位身份证转成18位
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var nTemp = 0, i;
        num = num.substr(0, 6) + '19' + num.substr(6, num.length - 6);
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i];
        }
        num += arrCh[nTemp % 11];
        return true;
      }
    }
    if (len == 18) {
      re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
      var arrSplit = num.match(re);

      //检查生日日期是否正确
      var dtmBirth = new Date(arrSplit[2] + "/" + arrSplit[3] + "/" + arrSplit[4]);
      var bGoodDay;
      bGoodDay = (dtmBirth.getFullYear() == Number(arrSplit[2])) && ((dtmBirth.getMonth() + 1) == Number(arrSplit[3])) && (dtmBirth.getDate() == Number(arrSplit[4]));
      if (!bGoodDay) {
        return false;
      }
      else {
        //检验18位身份证的校验码是否正确。
        //校验位按照ISO 7064:1983.MOD 11-2的规定生成，X可以认为是数字10。
        var valnum;
        var arrInt = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2);
        var arrCh = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2');
        var nTemp = 0, i;
        for (i = 0; i < 17; i++) {
          nTemp += num.substr(i, 1) * arrInt[i];
        }
        valnum = arrCh[nTemp % 11];
        if (valnum != num.substr(17, 1)) {
          return false;
        }
        return true;
      }
    }
    return false;
  },
  /**
   * 时间戳格式化函数
   * @param  {string} format    格式
   * @param  {int}    timestamp 要格式化的时间 默认为当前时间
   * @return {string}           格式化的时间字符串
   */
  date (format, timestamp) {
    var a, jsdate=((timestamp) ? new Date(timestamp*1000) : new Date());
    var pad = function(n, c){
      if((n = n + "").length < c){
        return new Array(++c - n.length).join("0") + n;
      } else {
        return n;
      }
    };
    var txt_weekdays = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    var txt_ordin = {1:"st", 2:"nd", 3:"rd", 21:"st", 22:"nd", 23:"rd", 31:"st"};
    var txt_months = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    var f = {
      // Day
      d: function(){return pad(f.j(), 2)},
      D: function(){return f.l().substr(0,3)},
      j: function(){return jsdate.getDate()},
      l: function(){return txt_weekdays[f.w()]},
      N: function(){return f.w() + 1},
      S: function(){return txt_ordin[f.j()] ? txt_ordin[f.j()] : 'th'},
      w: function(){return jsdate.getDay()},
      z: function(){return (jsdate - new Date(jsdate.getFullYear() + "/1/1")) / 864e5 >> 0},

      // Week
      W: function(){
        var a = f.z(), b = 364 + f.L() - a;
        var nd2, nd = (new Date(jsdate.getFullYear() + "/1/1").getDay() || 7) - 1;
        if(b <= 2 && ((jsdate.getDay() || 7) - 1) <= 2 - b){
          return 1;
        } else{
          if(a <= 2 && nd >= 4 && a >= (6 - nd)){
            nd2 = new Date(jsdate.getFullYear() - 1 + "/12/31");
            return date("W", Math.round(nd2.getTime()/1000));
          } else{
            return (1 + (nd <= 3 ? ((a + nd) / 7) : (a - (7 - nd)) / 7) >> 0);
          }
        }
      },

      // Month
      F: function(){return txt_months[f.n()]},
      m: function(){return pad(f.n(), 2)},
      M: function(){return f.F().substr(0,3)},
      n: function(){return jsdate.getMonth() + 1},
      t: function(){
        var n;
        if( (n = jsdate.getMonth() + 1) == 2 ){
          return 28 + f.L();
        } else{
          if( n & 1 && n < 8 || !(n & 1) && n > 7 ){
            return 31;
          } else{
            return 30;
          }
        }
      },

      // Year
      L: function(){var y = f.Y();return (!(y & 3) && (y % 1e2 || !(y % 4e2))) ? 1 : 0},
      //o not supported yet
      Y: function(){return jsdate.getFullYear()},
      y: function(){return (jsdate.getFullYear() + "").slice(2)},

      // Time
      a: function(){return jsdate.getHours() > 11 ? "pm" : "am"},
      A: function(){return f.a().toUpperCase()},
      B: function(){
        // peter paul koch:
        var off = (jsdate.getTimezoneOffset() + 60)*60;
        var theSeconds = (jsdate.getHours() * 3600) + (jsdate.getMinutes() * 60) + jsdate.getSeconds() + off;
        var beat = Math.floor(theSeconds/86.4);
        if (beat > 1000) beat -= 1000;
        if (beat < 0) beat += 1000;
        if ((String(beat)).length == 1) beat = "00"+beat;
        if ((String(beat)).length == 2) beat = "0"+beat;
        return beat;
      },
      g: function(){return jsdate.getHours() % 12 || 12},
      G: function(){return jsdate.getHours()},
      h: function(){return pad(f.g(), 2)},
      H: function(){return pad(jsdate.getHours(), 2)},
      i: function(){return pad(jsdate.getMinutes(), 2)},
      s: function(){return pad(jsdate.getSeconds(), 2)},
      //u not supported yet

      // Timezone
      //e not supported yet
      //I not supported yet
      O: function(){
        var t = pad(Math.abs(jsdate.getTimezoneOffset()/60*100), 4);
        if (jsdate.getTimezoneOffset() > 0) t = "-" + t; else t = "+" + t;
        return t;
      },
      P: function(){var O = f.O();return (O.substr(0, 3) + ":" + O.substr(3, 2))},
      //T not supported yet
      //Z not supported yet

      // Full Date/Time
      c: function(){return f.Y() + "-" + f.m() + "-" + f.d() + "T" + f.h() + ":" + f.i() + ":" + f.s() + f.P()},
      //r not supported yet
      U: function(){return Math.round(jsdate.getTime()/1000)}
    };

    return format.replace(/[]?([a-zA-Z])/g, function(t, s){
      if( t!=s ){
        // escaped
        return s;
      } else if( f[s] ){
        // a date function exists
        return f[s]();
      } else{
        // nothing special
        return s;
      }
    });
  },
  isPc(){
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    // localStorage.setItem('isiphone',flag)
    return !flag;
  },
  Alert(a,text, type, time) {//success,info,warning,error
    a.message.status = '';
    clearTimeout(a.timeout);
    a.message.text = (typeof text == 'string') && text ? text : '我是默认';
    a.message.time = time ? time : 2000;
    a.message.type = 'c-message--' + (type ? type : 'info');
    a.message.show = true;
    a.message.status = 'messageFadeInDown';
    a.timeout = setTimeout(()=>{
        a.message.status = 'messageFadeOutUp';
        // console.log(a.message);
    }, a.message.time);
  },
  logout(){
    localStorage.removeItem('access_token');
    localStorage.removeItem('memberInfo');
    localStorage.removeItem('phone');
    localStorage.removeItem('enroll_type');
  },
}



// WEBPACK FOOTER //
// ./src/utils/request.js